export enum SalesViewMode {
    Standard = 'standard',
    Showroom = 'traditional',
    SalesIntake = 'sales_intake'
}
